export const convertToSelectValue = (value: string | string[] | undefined) => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  if (typeof value === "string") return [value];
  else throw new Error("Invalid value type");
};
